export const COPY_STATE_VALUE = "COPY_STATE_VALUE";



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/state-copier/src/actions/actionTypes.js